<style scoped lang="less">
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;

	.sclectlable {
		margin-right: 20px;
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #f7f7f7;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	// button:last-child {
	// 	background-color: #ff8300;
	// }

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
		color: #333;
		font-weight: 600 !important;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		background-color: #f41127;
	}
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.avatar-uploader .el-upload:hover {
	border-color: #409eff;
}
.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.avatar {
	width: 178px;
	height: 178px;
	display: block;
}

.tabls {
	transition: all 1s;
}
</style>
<template>
	<div>
		<titles titlename="消息管理" titlecontent="这里可以消息管理" :mbx="paths"></titles>

		<div class="manageselect">
			<div class="sclectlable">
				<div>
					<el-select v-model="pagesobj.MST_GUID" clearable placeholder="请选择消息类型">
						<el-option v-for="item in rtlist" :key="item.MST_GUID" :label="item.MST_Name" :value="item.MST_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="sclectlable">
				<div><el-input placeholder="请输入消息名称" v-model="pagesobj.MS_Title" clearable></el-input></div>
			</div>

			<div class="primarybtn" @click="getresours()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>
		<div class="resourbtn">
			<el-button type="primary" size="small" icon="fa fa-plus" @click="createmessage">创建消息</el-button>
			<!-- <el-button type="primary" size="small" icon="el-icon-upload">批量删除</el-button> -->
		</div>

		<el-dialog title="添加消息" center append-to-body destroy-on-close :visible.sync="dialogVisible" :before-close="handleClose">
			<el-form label-width="120px" :model="addmess" :rules="rules" ref="ruleForm">
				<el-form-item label="消息标题" prop="MS_Title"><el-input v-model="addmess.MS_Title" placeholder="请输入消息标题"></el-input></el-form-item>
				<el-form-item label="消息类型" prop="MST_GUID">
					<el-select v-model="addmess.MST_GUID" clearable placeholder="请选择消息类型">
						<el-option v-for="item in rtlist" :key="item.MST_GUID" :label="item.MST_Name" :value="item.MST_GUID"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="封面图片" prop="MS_Image">
					<el-upload
						class="avatar-uploader"
						:action="baseurl1"
						list-type="picture-card"
						:file-list="fileList"
						:headers="{ Authorization: token }"
						:limit="1"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload"
						:on-remove="handleRemove"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>

				<el-form-item label="消息内容" prop="MS_Content">
					<tinymce-editor v-model="addmess.MS_Content" ref="editor" v-if="dialogVisible">
						<!--  * tinymce-editor 编辑富文本 
						 控制显示 dialogVisible
						 ref 获取
						 -->
					</tinymce-editor>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
					<el-button @click="resetForm('ruleForm')">重置</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="修改消息" center append-to-body destroy-on-close :visible.sync="editdialogVisible" :before-close="handleClose">
			<el-form label-width="120px" :model="addmess" :rules="rules" ref="ruleForm">
				<el-form-item label="消息标题" prop="MS_Title"><el-input v-model="addmess.MS_Title" placeholder="请输入消息标题"></el-input></el-form-item>
				<el-form-item label="消息类型" prop="MST_GUID">
					<el-select v-model="addmess.MST_GUID" clearable placeholder="请选择消息类型">
						<el-option v-for="item in rtlist" :key="item.MST_GUID" :label="item.MST_Name" :value="item.MST_GUID"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="封面图片" prop="MS_Image">
					<el-upload
						class="avatar-uploader"
						:action="baseurl1"
						list-type="picture-card"
						:file-list="fileList"
						:headers="{ Authorization: token }"
						:limit="1"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload"
						:on-remove="handleRemove"
					>
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>

				<el-form-item label="消息内容" prop="MS_Content" v-if="editdialogVisible">
					<div>
						<tinymce-editor v-model="addmess.MS_Content" ref="editor">
							<!--  * tinymce-editor 编辑富文本 
							 控制显示 dialogVisible
							 ref 获取
							 -->
						</tinymce-editor>
					</div>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="confirmsh('ruleForm')">立即修改</el-button>
					<el-button @click="resetForm('ruleForm')">重置</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pageSize" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" class="tabls" border style="width: 100%">
							<el-table-column type="selection" :resizable="false" width="55"></el-table-column>
							<el-table-column label="消息类型" :resizable="false" prop="MST_Name" width="100">
								<template slot-scope="scope">
									<p :title="scope.row.MST_Name">{{ scope.row.MST_Name }}</p>
								</template>
							</el-table-column>
							<el-table-column label="消息标题" :resizable="false" prop="MS_Title">
								<template slot-scope="scope">
									<p :title="scope.row.MS_Title" style="text-align: left;">{{ scope.row.MS_Title }}</p>
								</template>
							</el-table-column>
							<el-table-column label="消息内容" :resizable="false" prop="MS_Content">
								<template slot-scope="scope">
									<p :title="scope.row.MS_Content" style="cursor: pointer;">{{ scope.row.MS_Content }}</p>
								</template>
							</el-table-column>
							<el-table-column label="观看人数" :resizable="false" prop="MS_WatchCount" width="100"></el-table-column>
							<el-table-column label="消息图片" :resizable="false" prop="ui_UserName" width="200">
								<template slot-scope="scope">
									<img :src="scope.row.MS_Image" style="width: 150px;height: 120px;border-radius: 10px;" alt="这是一张消息图片" srcset="" />
								</template>
							</el-table-column>
							<el-table-column label="创建时间" :resizable="false" prop="MS_CreateTime" width="200"></el-table-column>
							<el-table-column label="操作" :resizable="false" fixed="right" width="200px">
								<template slot-scope="scope">
									<el-button plain size="mini" @click="editszy(scope.row)" style="background-color: #00e2e2;">编辑</el-button>
									<el-popconfirm title="是否删除该条记录？" @confirm="deleteresce(scope.row)">
										<el-button slot="reference" plain size="mini" style="background-color: #ec0f25;">删除</el-button>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { setbaseurl } from '@/utils/utils.js';

import { MessageUpdate, GetPageMessageLists, MessageDelete, GetMessagetypeList, MessageDetails, MessageAdd } from '@/request/api/homesview/yunhomes/yunhom.js';

import TinymceEditor from '@/components/Editor/Editor.vue';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 标题
			paths: [
				{
					path: '/homesview/testists/information',
					name: '消息管理'
				}
			],
			rules: {
				MS_Title: [{ required: true, message: '请输入消息标题', trigger: 'blur' }],
				MST_GUID: [{ required: true, message: '请输入选择消息类型', trigger: 'blur' }],
				MS_Image: [{ required: true, message: '请输入选择图片', trigger: 'blur' }],
				MS_Content: [{ required: true, message: '请输入消息内容', trigger: 'blur' }]
			},
			totalall: 0,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				MS_Title: '',
				MST_GUID: ''
			},
			pageSize: 10,
			addmess: {
				MS_Title: '',
				MS_Content: '',
				MS_Image: '',
				MST_GUID: ''
			},
			tabsnun: 1,
			tableData: [],
			// 获取专业、岗位、资源类型列表
			rtlist: [],
			dialogVisible: false,
			editdialogVisible: false,
			// 图片 上传
			imageUrl: '',
			baseurl1: '',
			token: 'Bearer ' + localStorage.getItem('token'),
			zyaccept: '.jpg,.png,.svg',
			fileList: []
		};
	},
	components: {
		titles,
		TinymceEditor
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.baseurl1 = setbaseurl() + '/Courses/UploadFileAsync';
		// console.log(this.$refs.editors.inites);
		this.get();
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					// alert('submit!');
					this.addmessage();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.fileList = [];
		},
		createmessage() {
			this.dialogVisible = true;
			this.resetForm('ruleForm');
			// this.$refs.editor.inites()
		},
		handleAvatarSuccess(res, file) {
			// console.log(res);
			if (res.code > 0) {
				this.addmess.MS_Image = res.data.url;
			} else {
				this.$message('上传失败请重新上传');
			}
		},
		beforeAvatarUpload(file) {
			// console.log(file);
			const fileSuffix = file.name.substring(file.name.lastIndexOf('.'));
			const whiteList = this.zyaccept.split(',');
			const isLt2M = file.size / 1024 / 1024 < 2;
			const isJPG = true;

			if (whiteList.indexOf(fileSuffix) === -1) {
				this.$message('上传文件只能是' + this.zyaccept + '格式');
				this.isJPG = false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
			}

			return isJPG && isLt2M;
		},
		handleRemove(file, fileList) {
			// console.log(file, fileList);
			this.fileList = fileList;
		},
		addmessage() {
			MessageAdd(this.addmess).then(res => {
				// console.log(addmess);
				if (res.data.code > 0) {
					this.resetForm('ruleForm');
					this.$message.success(res.data.msg);
					this.dialogVisible = false;
					this.getresours();
				}
			});
		},
		handlePictureCardPreview(file) {
			// this.dialogImageUrl = file.url;
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		changetablesize() {
			this.pagesobj.pageSize = this.pageSize;
			this.getresours();
		},

		editszy(itm) {
			// 点击编辑 获取详情
			// this.resetForm('ruleForm')
			this.dialogVisible = false;
			this.editdialogVisible = true;
			let source = {
				MS_GUID: itm.MS_GUID
			};
			// this.$refs.editor.inites()
			MessageDetails(source).then(res => {
				// console.log(res);
				if (res.data.code > 0) {
					// console.log(this.$refs.editor.inites)
					this.addmess = res.data.data;
					this.fileList = [
						{
							url: res.data.data.MS_Image
						}
					];
				}
			});
		},
		confirmsh(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					// alert('submit!');
					MessageUpdate(this.addmess).then(res => {
						if (res.data.code > 0) {
							this.resetForm('ruleForm');
							this.editdialogVisible = false;
							this.$message.success(res.data.msg);
							this.getresours();
						}
					});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		deleteresce(re) {
			let review = {
				MS_GUID: re.MS_GUID
			};
			MessageDelete(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.getresours();
				}
			});
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.getresours();
		},
		get() {
			this.getResourceType();
			this.getresours();
		},
		getResourceType() {
			GetMessagetypeList().then(res => {
				if (res.data.code > 0) {
					this.rtlist = res.data.data;
				}
			});
		},
		getresours() {
			GetPageMessageLists(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					// console.log(res)
					this.tableData = res.data.data.list;
					this.totalall = res.data.data.totalCount;
				}
			});
		}
	}
};
</script>
